module.exports = __webpack_public_path__ + "img/FR30047.b764e91e.png";